"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var CreateUserModal_vue_1 = __importDefault(require("./CreateUserModal.vue"));
var event_bus_1 = require("../../event-bus");
exports.default = vue_1.default.extend({
    name: "create-user",
    components: {
        CreateUserModal: CreateUserModal_vue_1.default,
        VButton: VButton_vue_1.default
    },
    props: {
        roles: {
            type: Array,
            required: true
        },
        districts: {
            type: Array,
            required: true
        },
        units: {
            type: Array,
            required: true
        }
    },
    data: function () {
        return {
            showModal: false
        };
    },
    methods: {
        onCreateUser: function (user) {
            event_bus_1.EventBus.$emit(event_bus_1.events.user.create, user);
        }
    }
});
